import { Package } from './package';
import { Product } from './product';
import { BaseUser } from './user';

export class OrderBundleUnit {
  constructor(data) {
    this.id = data.id;
    this.isRefunded = data.isRefunded;

    /** @type {Product} */
    this.product = data.product;

    /** @type {BaseUser} */
    this.assignee = data.assignee;
  }
}

export class OrderBundle {
  constructor(data) {
    this.bundleId = data.bundleId;

    /** @type {Package}  */
    this.package = data.package;

    /** @type {OrderBundleUnit[]} */
    this.units = data.units;
  }
}
